import { render } from "./rmsLogin.vue?vue&type=template&id=b2e29a04"
import script from "./rmsLogin.vue?vue&type=script&lang=js"
export * from "./rmsLogin.vue?vue&type=script&lang=js"

import "./rmsLogin.vue?vue&type=style&index=0&id=b2e29a04&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__